import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { LegacyContentExtensionHandlerProps } from './LegacyContentExtensionHandler.tsx';

export const LegacyContentExtensionHandler: LoadableType<LegacyContentExtensionHandlerProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-LegacyContentExtensionHandler" */ './LegacyContentExtensionHandler.tsx'
				)
			).LegacyContentExtensionHandler,
	});
